// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// WEBPAGE PARAMETER SCHEMA
/////////////////////////////////////////

export const WebpageParameterSchema = z.object({
  name: z.string(),
  description: z.string(),
  type: z.string(),
})

export type WebpageParameter = z.infer<typeof WebpageParameterSchema>

export default WebpageParameterSchema;
